// Environments should remain in order of lock priority.
export const ENVIRONMENTS = ["development", "testwest", "test", "production"];
